import { getLocale } from '../i18n';

function localeCode(): string {
  return getLocale() === 'en' ? 'en-GB' : 'de-DE';
}

function dateSeparator(): string {
  return getLocale() === 'en' ? '/' : '.';
}

export function formatDate(value?: string | null): string {
  if (!value) {
    return '-';
  }

  const sep = dateSeparator();

  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [year, month, day] = value.split('-');
    return `${day}${sep}${month}${sep}${year}`;
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return value;
  }

  return date.toLocaleDateString(localeCode(), {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
}
